// extracted by mini-css-extract-plugin
module.exports = {"mypage_subsc_cancel_confirm":"cancel_mypage_subsc_cancel_confirm__3L1Xx","mypage_subsc_cancel_buttons":"cancel_mypage_subsc_cancel_buttons__3zs6p"};